import { render, staticRenderFns } from "./SelectAuditoresMultiple.vue?vue&type=template&id=60b099df"
import script from "./SelectAuditoresMultiple.vue?vue&type=script&lang=js"
export * from "./SelectAuditoresMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports